import type { ColorSystemOptions } from '@mui/material/styles';

import { colors } from '../tokens';

export const darkScheme: ColorSystemOptions = {
  palette: {
    primary: {
      main: colors.green[500],
    },
    error: { main: colors.red[600] },
    warning: { main: colors.warning[600] },
    info: { main: colors.green[500] },
    success: {
      light: colors.green[50],
      main: colors.green[600],
    },
    background: {
      default: colors.black[950],
      paper: colors.grayTrue[850],
      bgSecondaryAlt: colors.black[850],
      bgSecondarySubtle: colors.black[950],
    },
    text: {
      primary: colors.black[25],
      secondary: colors.black[100],
      disabled: colors.black[600],
      primaryOnBrand: colors.black[50],
      secondaryHover: colors.black[100],
      secondaryOnBrand: '#CECFD2',
      tertiary: colors.black[200],
      tertiaryHover: colors.black[200],
      tertiaryOnBrand: '#94979C',
      quaternary: colors.black[200],
      quaternaryOnBrand: '#94979C',
      placeholder: colors.black[300],
      placeholderSubtle: colors.black[300],
      brandPrimary: colors.green[500],
      brandSecondary: colors.green[600],
      brandSecondaryHover: colors.green[600],
      brandTertiary: colors.green[700],
      brandTertiaryAlt: colors.grayTrue[50],
      errorPrimary: colors.red[400],
      warningPrimary: colors.warning[400],
      successPrimary: colors.success[400],
    },
    divider: colors.black[600],
    teal: colors.teal,
    black: colors.black,
    green: colors.green,
    gray: colors.gray,
    grayTrue: colors.grayTrue,
    red: colors.red,
  },
};
